<p>move-selection works!</p>
